import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useAuth } from "../../../../../hooks";

const SearchBar = ({
  selected,
  placeholder,
  handleSearch,
  handleUpdateReactionStatus,
  handleUpdateReportedStatus,
  handleDeleteReaction,
}) => {
  const { currentUser } = useAuth();
  const [reactionStatusOptions, setReactionStatusOptions] = useState(false);
  const [reportedStatusOptions, setReportedStatusOptions] = useState(false);

  useEffect(() => {
    if (selected && selected.length < 1) {
      setReactionStatusOptions(false);
      setReportedStatusOptions(false);
    }
  }, [selected]);

  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        onChange={
          handleSearch ? (e) => handleSearch(e) : () => console.log("search")
        }
        // value={""}
        // handleChange={}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <TrendingFlatIcon fontSize="large" style={{ color: "#919191" }} />
              {/* <span
                style={statusTextSTyles}
                onClick={() => handleDeleteReaction()}
              >
                Delete
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000" }}
              /> */}
              <span
                style={{
                  ...statusTextSTyles,
                  color: reactionStatusOptions ? "#9447AF" : "#00A7CD",
                }}
                onClick={() => {
                  setReactionStatusOptions(true);
                  setReportedStatusOptions(false);
                }}
              >
                Reaction Status
              </span>
            </Fragment>
          )}
          {reactionStatusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReactionStatus("approved")}
              >
                Approved
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReactionStatus("pending")}
              >
                Pending
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReactionStatus("denied")}
              >
                Denied
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReactionStatus("removed")}
              >
                Removed
              </span>
            </Fragment>
          )}
          {currentUser?.role === "moderator" ? undefined : (
            <Fragment>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000" }}
              />
              <span
                style={{
                  ...statusTextSTyles,
                  color: reportedStatusOptions ? "#9447AF" : "#00A7CD",
                }}
                onClick={() => {
                  setReactionStatusOptions(false);
                  setReportedStatusOptions(true);
                }}
              >
                Reported Status
              </span>
            </Fragment>
          )}
          {reportedStatusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReportedStatus("flagged")}
              >
                Flagged
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReportedStatus("in review")}
              >
                In Review
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReportedStatus("pending")}
              >
                Pending
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateReportedStatus("resolved")}
              >
                Resolved
              </span>
            </Fragment>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
